export default "__VITE_ASSET__DM3F$pi8__"